import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "en", setLang: () => {} });

const DICT = {
  en: {
    "brand.title": "BigFeels",
    "brand.tagline": "A safe place for parents",
    "brand.initial": "B",
    "nav.home": "Home",
    "nav.tips": "Tips",
    "nav.ask": "Ask The Gang",
    "nav.breathe": "Breathe",
    "nav.quiz": "Quiz",
    "nav.mood": "Mood",
    "nav.wins": "Wins",
    "footer.quote": "There are no perfect parents — only parents who try.",
    "footer.credit": "powered by the 6 books of Le Gang Des Émotions® by Aurélia P.",
    "footer.press": "Press room — media kit",
    "home.hero.badge": "A safe place — for you first",
    "home.hero.title1": "Big feelings,",
    "home.hero.title2": "held gently.",
    "home.hero.subtitle": "Meet Grr, Bandit, Max, Hoohoo, Cloudy and Sparky — the 6 mascots that form Le Gang Des Émotions®. Fun, warm, deeply serious tools to help you hold your child's storms — and yours. A judgment-free space, because you deserve care too.",
    "home.cta.explore": "Explore tips",
    "home.cta.breathe": "Take 2 min for me",
    "home.mantra.label": "Today's mantra",
    "home.mascots.title": "Meet Le Gang",
    "home.mascots.subtitle": "Six mascots — one emotion each. Every one becomes your ally.",
    "home.coming.badge": "Coming soon · the 6th",
    "home.coming.title": "Sparky the Fox — Joy",
    "home.coming.subtitle": "Because joy is a superpower we can grow. Every day.",
    "home.coming.book": "My Great Joy — Book 6",
    "home.coming.email.placeholder": "your@email.com",
    "home.coming.notify": "Notify me",
    "home.coming.thanks": "You're on the list 🦊",
    "home.sparky.badge": "Sparky is here — the 6th book is live",
    "home.sparky.title": "Sparky the fox has joined The Gang",
    "home.sparky.subtitle": "\"My Great Joy\" — piloting the sun-rocket. For big joyful energy that sometimes overflows.",
    "home.sparky.cta": "Meet Sparky",
    "home.actions.title": "Where would you like to go?",
    "home.action.ask": "Ask The Gang",
    "home.action.ask.desc": "A companion inspired by the books",
    "home.action.breathe": "Breathe & Release",
    "home.action.breathe.desc": "Guided breath, worry box, mantras",
    "home.action.quiz": "Parenting Quiz",
    "home.action.quiz.desc": "\"What would you do if...\"",
    "home.action.mood": "Today's Weather",
    "home.action.mood.desc": "Track how you both feel",
    "home.safe.label": "A gentle reminder",
    "home.safe.title": "You cannot pour from an empty cup.",
    "home.safe.body": "Every time you kneel to your child's level, breathe before reacting, or simply say \"I'm here\" — you are rebuilding the world for them. And that's more than enough for today.",
    "home.books.badge": "The paper collection",
    "home.books.title": "Bring The Gang home",
    "home.books.body": "The 5 illustrated books by Aurélia P. — the perfect bedtime companions for the emotions you just met.",
    "home.books.cta": "Discover the books →",
    "home.books.pinterest": "Pinterest",
    "home.chat.badge": "Ask The Gang",
    "home.chat.title": "Something on your mind? Ask The Gang right now.",
    "home.chat.subtitle": "One question, one soft answer — inspired by the 6 books.",
    "home.chat.openFull": "Open full chat",
    "home.chat.continue": "Continue the conversation",
    "home.chat.sug.1": "How do I stay calm during a meltdown?",
    "home.chat.sug.2": "My child is scared of the dark — help.",
    "home.chat.sug.3": "How do I build her confidence?",
    "mascot.explore": "Explore",
    "tips.title": "Tips library",
    "tips.subtitle": "Magic phrases, exercises and key insights — pulled straight from the 6 books. Filter by emotion.",
    "tips.filter.all": "All",
    "tips.loading": "Loading…",
    "tips.cat.phrase": "Magic phrase",
    "tips.cat.exercise": "Exercise",
    "tips.cat.info": "Good to know",
    "tips.with": "with",
    "ask.badge": "Claude Sonnet · empathetic",
    "ask.title": "Ask Le Gang",
    "ask.subtitle": "Describe a situation. Ask anything. The Gang answers with warmth, never judgment.",
    "ask.thinking": "Le Gang is thinking…",
    "ask.input.placeholder": "Describe the situation…",
    "ask.send": "Send",
    "ask.error": "Sorry, we couldn't reply just now. Try again in a moment.",
    "ask.hello": "Hi there 🌿 We are Le Gang — Grr, Bandit, Max, Hoohoo and Cloudy. Together we're your gentle companions in the parenting adventure. Tell us what's going on with your child today — we'll find a soft path forward, together.",
    "ask.sug.1": "My 4-year-old melts down at bedtime — what do I do?",
    "ask.sug.2": "How can I help him when he's scared of school?",
    "ask.sug.3": "She won't try new things because she's afraid to fail.",
    "ask.sug.4": "I'm exhausted. How do I stay calm during her tantrums?",
    "ask.sug.5": "How do I comfort a child who's sad and can't explain why?",
    "breathe.title": "Your quiet corner",
    "breathe.subtitle": "This one's for you, parent. Breathe. Put your worries down. Pocket a mantra. Zero judgment here.",
    "breathe.badge": "4-2-4 breathing",
    "breathe.h2": "Take two minutes",
    "breathe.instructions": "Feet on the floor. Follow the circle. Breathe with it.",
    "breathe.ready": "Ready?",
    "breathe.start": "Start",
    "breathe.stop": "Stop",
    "breathe.phase.in": "Breathe in…",
    "breathe.phase.hold": "Hold…",
    "breathe.phase.out": "Breathe out…",
    "breathe.phase.pause": "Pause…",
    "worry.badge": "Worry box",
    "worry.title": "Empty the bag",
    "worry.subtitle": "Write a worry, put it down. When ready, let it go.",
    "worry.placeholder": "e.g. I feel overwhelmed by his evening meltdowns…",
    "worry.submit": "Drop it in",
    "worry.saved": "Worry safely tucked away 🌿",
    "worry.empty": "Your box is empty. Breathe — that's already a lot.",
    "worry.release": "Let it go",
    "mantra.badge": "Mantra to take with you",
    "mantra.refresh": "Draw another",
    "quiz.title": "What would you do?",
    "quiz.subtitle": "Read the scenario. Pick the gentlest reaction. There's no wrong answer — some paths are just softer than others.",
    "quiz.loading": "Loading the quiz…",
    "quiz.progress": "Question",
    "quiz.progress.of": "of",
    "quiz.score": "Score",
    "quiz.why": "Why?",
    "quiz.next": "Next question →",
    "quiz.finish": "See your result",
    "quiz.done.title": "Well done!",
    "quiz.done.subtitle": "You finished the parenting quiz.",
    "quiz.result.high": "You've internalized the tools. Bravo, attentive parent!",
    "quiz.result.mid": "You're on the right track. Keep exploring the tips.",
    "quiz.result.low": "No worries — that's why the Gang exists. Every read makes you steadier.",
    "quiz.restart": "Start over",
    "mood.title": "Today's weather",
    "mood.subtitle": "How is it blowing today? Track your mood and your child's. Over time, patterns emerge.",
    "mood.streak": "{n}-day streak",
    "mood.streak.one": "{n}-day streak",
    "mood.parent": "Me, as a parent",
    "mood.child": "My child",
    "mood.note.label": "A note? (optional)",
    "mood.note.placeholder": "e.g. tough day at school, lots of frustration…",
    "mood.submit": "Save today's weather",
    "mood.submitting": "Saving…",
    "mood.saved": "Today's weather saved 🌤️",
    "mood.history": "Recent history",
    "mood.empty": "No entries yet.",
    "mood.parent.label": "Parent",
    "mood.child.label": "Child",
    "mood.emo.1": "Very low",
    "mood.emo.2": "Meh",
    "mood.emo.3": "Okay",
    "mood.emo.4": "Good",
    "mood.emo.5": "Radiant",
    "sos.fab": "I need help now",
    "sos.badge": "Take a breath",
    "sos.title": "You're safe here.",
    "sos.subtitle": "6 gentle steps. Take them one at a time — you don't have to be perfect.",
    "sos.close": "Close",
    "sos.next": "Next step →",
    "sos.toBreathe": "Go breathe →",
    "lang.switch": "Language",
    "locale": "en-US",
    "profile.badge": "Child profile",
    "profile.title": "Tell Le Gang about your child",
    "profile.subtitle": "Optional — but it lets Le Gang tailor every answer to your family.",
    "profile.name": "First name",
    "profile.name.placeholder": "e.g. Léo",
    "profile.age": "Age",
    "profile.emotion": "Current main emotion (optional)",
    "profile.save": "Save profile",
    "wins.badge": "Wins wall",
    "wins.title": "Tiny wins, huge power.",
    "wins.subtitle": "Share an anonymous small victory from today. Read others'. You are less alone than you think.",
    "wins.placeholder": "e.g. I breathed before I shouted today.",
    "wins.submit": "Share my win",
    "wins.saved": "Shared — bravo 🌿",
    "wins.empty": "Be the first to share a win today.",
    "emo.joy": "Joy",
    "emo.calm": "Calm",
    "emo.confidence": "Confidence",
    "emo.anger": "Anger",
    "emo.anxiety": "Anxiety",
    "emo.fear": "Fear",
    "emo.sadness": "Sadness",
    "mood.emotions.label": "Emotions of the day (optional)",
    "mood.emotions.hint": "Tap any that fit — they help your dashboard grow gentler over time.",
    "dash.title": "Your gentle dashboard",
    "dash.subtitle": "A soft look at the last 30 days. No pressure, no scores — just patterns.",
    "dash.stat.parent": "Parent mood",
    "dash.stat.child": "Child mood",
    "dash.stat.streak": "Streak",
    "dash.stat.streak.one": "day in a row",
    "dash.stat.streak.plural": "days in a row",
    "dash.stat.wins": "Wins shared",
    "dash.stat.wins.sub": "· {n} worries dropped",
    "dash.stat.none": "no entry yet",
    "dash.pie.title": "Emotions of the season",
    "dash.pie.badge": "last 30 days",
    "dash.pie.empty": "Add a few emotion tags when you save today's weather — your chart will bloom here.",
    "dash.insight.badge": "The Gang's weekly recap",
    "dash.insight.title": "Your weekly recap",
    "dash.insight.subtitle": "A warm summary of the week, written by Le Gang. On-demand, whenever you'd like.",
    "dash.insight.button": "Generate my recap",
    "dash.insight.regenerate": "Refresh my recap",
    "dash.insight.loading": "The Gang is writing…",
    "dash.insight.error": "Couldn't write your recap. Try again in a moment.",
    "dash.pdf.button": "Monthly PDF report",
    "dash.pdf.loading": "Preparing…",
    "dash.pdf.saved": "Report downloaded 🌿",
    "dash.pdf.error": "Couldn't build the PDF. Try again in a moment.",
  },
  fr: {
    "brand.title": "Le Gang Des Émotions®",
    "brand.tagline": "Un lieu sûr pour les parents",
    "brand.initial": "G",
    "nav.home": "Accueil",
    "nav.tips": "Conseils",
    "nav.ask": "Demander au Gang",
    "nav.breathe": "Respirer",
    "nav.quiz": "Quiz",
    "nav.mood": "Humeur",
    "nav.wins": "Victoires",
    "footer.quote": "Il n'y a pas de parents parfaits — seulement des parents qui essaient.",
    "footer.credit": "propulsé par les 6 livres de Le Gang Des Émotions® d'Aurélia P.",
    "footer.press": "Espace presse — kit média",
    "home.hero.badge": "Un lieu sûr — pour vous d'abord",
    "home.hero.title1": "Les grandes émotions,",
    "home.hero.title2": "apprivoisées avec douceur.",
    "home.hero.subtitle": "Rencontrez Grr, Bandit, Max, Hoohoo, Cloudy et Sparky — les 6 mascottes qui forment Le Gang Des Émotions®. Fun, chaleureux, profondément sérieux : des outils concrets pour accueillir les tempêtes de votre enfant — et les vôtres. Un espace sans jugement, parce que vous aussi méritez d'être choyé·e.",
    "home.cta.explore": "Explorer les conseils",
    "home.cta.breathe": "Prendre 2 min pour moi",
    "home.mantra.label": "Mantra du jour",
    "home.mascots.title": "Rencontrez Le Gang",
    "home.mascots.subtitle": "Six mascottes, une émotion chacune. Chaque mascotte devient votre alliée.",
    "home.coming.badge": "Bientôt · la 6ème",
    "home.coming.title": "Sparky le renard — La Joie",
    "home.coming.subtitle": "Parce que la joie est un super-pouvoir qui se cultive. Chaque jour.",
    "home.coming.book": "Ma grande joie — Livre 6",
    "home.coming.email.placeholder": "votre@email.com",
    "home.coming.notify": "Me prévenir",
    "home.coming.thanks": "Vous êtes inscrit·e 🦊",
    "home.sparky.badge": "Sparky est arrivé — le 6e livre est là",
    "home.sparky.title": "Sparky le renard rejoint Le Gang",
    "home.sparky.subtitle": "« Ma grande joie » — piloter le soleil-fusée. Pour la grande joie qui déborde parfois.",
    "home.sparky.cta": "Rencontrer Sparky",
    "home.actions.title": "Où voulez-vous aller ?",
    "home.action.ask": "Demander au Gang",
    "home.action.ask.desc": "Un compagnon inspiré des livres",
    "home.action.breathe": "Respirer & lâcher prise",
    "home.action.breathe.desc": "Respiration guidée, boîte à soucis, mantras",
    "home.action.quiz": "Quiz parental",
    "home.action.quiz.desc": "« Que feriez-vous si… »",
    "home.action.mood": "Météo du jour",
    "home.action.mood.desc": "Suivre votre humeur et la sienne",
    "home.safe.label": "Un rappel doux",
    "home.safe.title": "On ne peut pas donner ce qu'on n'a pas.",
    "home.safe.body": "Chaque fois que vous vous mettez à sa hauteur, que vous respirez avant de réagir, ou que vous dites simplement « Je suis là » — vous reconstruisez le monde pour votre enfant. Et pour aujourd'hui, c'est déjà bien assez.",
    "home.books.badge": "La collection papier",
    "home.books.title": "Faites entrer Le Gang à la maison",
    "home.books.body": "Les 6 livres illustrés d'Aurélia P. — les compagnons parfaits pour le coucher, à lire avec les émotions rencontrées ici.",
    "home.books.cta": "Découvrir les livres →",
    "home.books.pinterest": "Pinterest",
    "home.chat.badge": "Demander au Gang",
    "home.chat.title": "Une question maintenant ? Posez-la au Gang.",
    "home.chat.subtitle": "Une question, une réponse douce — inspirée des 6 livres.",
    "home.chat.openFull": "Ouvrir le chat complet",
    "home.chat.continue": "Continuer la conversation",
    "home.chat.sug.1": "Comment rester calme pendant une crise ?",
    "home.chat.sug.2": "Mon enfant a peur du noir — aidez-moi.",
    "home.chat.sug.3": "Comment construire sa confiance en lui ?",
    "mascot.explore": "Découvrir",
    "tips.title": "Bibliothèque de conseils",
    "tips.subtitle": "Phrases magiques, exercices et notions clés extraits directement des 6 livres. Filtrez par émotion.",
    "tips.filter.all": "Toutes",
    "tips.loading": "Chargement…",
    "tips.cat.phrase": "Phrase magique",
    "tips.cat.exercise": "Exercice",
    "tips.cat.info": "À savoir",
    "tips.with": "avec",
    "ask.badge": "Claude Sonnet · empathique",
    "ask.title": "Demander au Gang",
    "ask.subtitle": "Décrivez une situation. Posez une question. Le Gang répond avec chaleur, jamais avec jugement.",
    "ask.thinking": "Le Gang réfléchit…",
    "ask.input.placeholder": "Décrivez la situation…",
    "ask.send": "Envoyer",
    "ask.error": "Désolé, nous n'avons pas pu répondre. Réessayez dans un instant.",
    "ask.hello": "Bonjour 🌿 Nous sommes Le Gang — Grr, Bandit, Max, Hoohoo et Cloudy. Ensemble, nous sommes vos compagnons doux dans l'aventure de la parentalité. Racontez-nous ce qui se passe avec votre enfant aujourd'hui — nous trouverons une piste douce, ensemble.",
    "ask.sug.1": "Mon enfant de 4 ans fait une crise au coucher, que faire ?",
    "ask.sug.2": "Comment l'aider quand il a peur d'aller à l'école ?",
    "ask.sug.3": "Elle n'ose pas essayer de nouvelles choses par peur d'échouer.",
    "ask.sug.4": "Je suis épuisée. Comment garder mon calme face à ses colères ?",
    "ask.sug.5": "Comment consoler un enfant qui est triste sans savoir pourquoi ?",
    "breathe.title": "Votre coin de calme",
    "breathe.subtitle": "Cet espace, c'est pour vous, parent. Respirez. Déposez vos soucis. Emportez un mantra. Aucun jugement ici.",
    "breathe.badge": "Respiration 4-2-4",
    "breathe.h2": "Prendre deux minutes",
    "breathe.instructions": "Les pieds au sol. Suivez le cercle. Respirez avec lui.",
    "breathe.ready": "Prêt·e ?",
    "breathe.start": "Commencer",
    "breathe.stop": "Arrêter",
    "breathe.phase.in": "Inspire…",
    "breathe.phase.hold": "Retiens…",
    "breathe.phase.out": "Expire…",
    "breathe.phase.pause": "Pause…",
    "worry.badge": "Boîte à soucis",
    "worry.title": "Vider le sac",
    "worry.subtitle": "Écrivez un souci, déposez-le. Quand vous êtes prêt·e, lâchez-le.",
    "worry.placeholder": "ex. je me sens dépassée par ses crises du soir…",
    "worry.submit": "Déposer",
    "worry.saved": "Souci confié à la boîte 🌿",
    "worry.empty": "Votre boîte est vide. Respirez — c'est déjà beaucoup.",
    "worry.release": "Lâcher prise",
    "mantra.badge": "Mantra à emporter",
    "mantra.refresh": "En tirer un autre",
    "quiz.title": "Quelle réaction parentale ?",
    "quiz.subtitle": "Lisez la situation, choisissez la réaction la plus douce. Aucune mauvaise réponse — juste des pistes plus douces que d'autres.",
    "quiz.loading": "Chargement du quiz…",
    "quiz.progress": "Question",
    "quiz.progress.of": "sur",
    "quiz.score": "Score",
    "quiz.why": "Pourquoi ?",
    "quiz.next": "Question suivante →",
    "quiz.finish": "Voir le résultat",
    "quiz.done.title": "Bravo !",
    "quiz.done.subtitle": "Vous avez terminé le quiz parental.",
    "quiz.result.high": "Vous maîtrisez les outils. Bravo, parent attentif·ve !",
    "quiz.result.mid": "Vous êtes sur la bonne voie. Continuez à explorer les conseils.",
    "quiz.result.low": "Pas de souci — c'est justement pour ça que Le Gang existe. Chaque lecture vous rend plus solide.",
    "quiz.restart": "Recommencer",
    "mood.title": "Météo du jour",
    "mood.subtitle": "Comment ça souffle aujourd'hui ? Notez votre humeur et celle de votre enfant. Avec le temps, les tendances apparaissent.",
    "mood.streak": "{n} jours consécutifs",
    "mood.streak.one": "{n} jour consécutif",
    "mood.parent": "Moi, en tant que parent",
    "mood.child": "Mon enfant",
    "mood.note.label": "Une note ? (facultatif)",
    "mood.note.placeholder": "ex. journée d'école compliquée, beaucoup de frustration…",
    "mood.submit": "Enregistrer la météo",
    "mood.submitting": "Enregistrement…",
    "mood.saved": "Météo du jour enregistrée 🌤️",
    "mood.history": "Historique récent",
    "mood.empty": "Aucune entrée pour l'instant.",
    "mood.parent.label": "Parent",
    "mood.child.label": "Enfant",
    "mood.emo.1": "Très bas",
    "mood.emo.2": "Bof",
    "mood.emo.3": "Ça va",
    "mood.emo.4": "Bien",
    "mood.emo.5": "Rayonnant",
    "sos.fab": "J'ai besoin d'aide",
    "sos.badge": "Respirez",
    "sos.title": "Vous êtes en sécurité ici.",
    "sos.subtitle": "6 étapes douces. Une à la fois — vous n'avez pas à être parfait·e.",
    "sos.close": "Fermer",
    "sos.next": "Étape suivante →",
    "sos.toBreathe": "Aller respirer →",
    "lang.switch": "Langue",
    "locale": "fr-FR",
    "profile.badge": "Profil enfant",
    "profile.title": "Parlez à Le Gang de votre enfant",
    "profile.subtitle": "Facultatif — mais permet à Le Gang d'adapter chaque réponse à votre famille.",
    "profile.name": "Prénom",
    "profile.name.placeholder": "ex. Léo",
    "profile.age": "Âge",
    "profile.emotion": "Émotion principale du moment (facultatif)",
    "profile.save": "Enregistrer",
    "wins.badge": "Mur des victoires",
    "wins.title": "De petites victoires, immenses forces.",
    "wins.subtitle": "Partagez anonymement une petite victoire du jour. Lisez celles des autres. Vous êtes moins seul·e qu'il n'y paraît.",
    "wins.placeholder": "ex. J'ai respiré avant de crier aujourd'hui.",
    "wins.submit": "Partager ma victoire",
    "wins.saved": "Partagée — bravo 🌿",
    "wins.empty": "Soyez le·la premier·ère à partager une victoire aujourd'hui.",
    "emo.joy": "Joie",
    "emo.calm": "Calme",
    "emo.confidence": "Confiance",
    "emo.anger": "Colère",
    "emo.anxiety": "Anxiété",
    "emo.fear": "Peur",
    "emo.sadness": "Tristesse",
    "mood.emotions.label": "Émotions du jour (facultatif)",
    "mood.emotions.hint": "Cochez celles qui résonnent — elles nourrissent doucement votre tableau de bord.",
    "dash.title": "Votre tableau de bord tout doux",
    "dash.subtitle": "Un regard bienveillant sur les 30 derniers jours. Aucune pression, aucun score — juste des tendances.",
    "dash.stat.parent": "Humeur parent",
    "dash.stat.child": "Humeur enfant",
    "dash.stat.streak": "Série en cours",
    "dash.stat.streak.one": "jour d'affilée",
    "dash.stat.streak.plural": "jours d'affilée",
    "dash.stat.wins": "Victoires partagées",
    "dash.stat.wins.sub": "· {n} soucis déposés",
    "dash.stat.none": "aucune entrée",
    "dash.pie.title": "Les émotions de la saison",
    "dash.pie.badge": "30 derniers jours",
    "dash.pie.empty": "Ajoutez quelques émotions en enregistrant la météo du jour — votre camembert fleurira ici.",
    "dash.insight.badge": "Le bilan du Gang",
    "dash.insight.title": "Votre bilan de la semaine",
    "dash.insight.subtitle": "Un petit résumé chaleureux de la semaine, écrit par Le Gang. À la demande, quand vous le souhaitez.",
    "dash.insight.button": "Générer mon bilan",
    "dash.insight.regenerate": "Rafraîchir mon bilan",
    "dash.insight.loading": "Le Gang écrit…",
    "dash.insight.error": "Bilan indisponible pour l'instant. Réessayez dans un instant.",
    "dash.pdf.button": "Rapport PDF du mois",
    "dash.pdf.loading": "Préparation…",
    "dash.pdf.saved": "Rapport téléchargé 🌿",
    "dash.pdf.error": "PDF indisponible. Réessayez dans un instant.",
  },
};

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("bf_lang") : null;
    if (saved === "fr" || saved === "en") return saved;
    if (typeof navigator !== "undefined" && navigator.language?.toLowerCase().startsWith("fr")) return "fr";
    return "en";
  });
  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem("bf_lang", l); } catch { /* ignore */ }
    if (typeof document !== "undefined") document.documentElement.lang = l;
  };
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
      document.title = lang === "fr"
        ? "Le Gang Des Émotions® — Un havre pour les parents"
        : "BigFeels — A Safe Place for Parents";
    }
  }, [lang]);
  const t = (key, vars) => {
    let s = DICT[lang]?.[key];
    if (s === undefined) {
      // Dev-only warning to catch translation gaps early (silent fallback masks them).
      if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
        // eslint-disable-next-line no-console
        console.warn(`[i18n] missing key "${key}" for lang "${lang}" — falling back to en`);
      }
      s = DICT.en[key] ?? key;
    }
    if (vars) for (const k in vars) s = s.replace(`{${k}}`, vars[k]);
    return s;
  };
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
